import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import Header from "../Header/Header";
import { AuthContext } from "../../contexts/AuthContext";

// Accesos rápidos con los mismos permisos del sidebar.
const ACCESOS = [
  { label: "Contenedores", desc: "Seguimiento de contenedores, surtidos y ventas", icon: "fas fa-ship", color: "#2563eb", href: "/MenuContenedores", perm: "contenedores" },
  { label: "Catálogos", desc: "Clientes, navieras, brokers y demás catálogos del sistema", icon: "fas fa-book-open", color: "#0d9488", href: "/MenuCatalogos", perm: "menuCatalogos" },
  { label: "Finanzas", desc: "Cargos, abonos, gastos y pagos por contenedor", icon: "fas fa-coins", color: "#16a34a", href: "/Finanzas", perm: "menuAdmin" },
  { label: "Costo Importacion", desc: "Gastos por contenedor y cuentas por pagar a brokers", icon: "fas fa-coins", color: "#ea580c", href: "/MenuGastos", perm: "menu_gastos" },
  { label: "Reportes", desc: "Reportes de operación", icon: "fas fa-chart-bar", color: "#7c3aed", href: "/MenuReportes", perm: "menuReportes" },
  { label: "Usuarios", desc: "Usuarios y permisos", icon: "fas fa-users-cog", color: "#475569", href: "/ListadoUsuarios", perm: "menu_usuarios" },
];

function HomeInicio() {
  const { user } = useContext(AuthContext);
  const [t, i18n] = useTranslation("global");

  const esCliente = user?.tipo === "Cliente";
  const tienePermiso = (perm) =>
    perm === "contenedores"
      ? !!(user?.menuContenedores || user?.menuContenedoresPS || user?.menuContenedoresClientes || user?.menuContenedoresEliezer)
      : !!user?.[perm];
  const accesos = ACCESOS.filter((a) => (esCliente ? a.perm === "contenedores" : tienePermiso(a.perm)));

  const hora = new Date().getHours();
  const saludo = hora < 12 ? t("Buenos días") : hora < 19 ? t("Buenas tardes") : t("Buenas noches");
  const fecha = new Date().toLocaleDateString(i18n.language === "en" ? "en-US" : "es-MX", {
    weekday: "long", day: "numeric", month: "long", year: "numeric",
  });

  return (
    <>
      <Header />
      <div className="container-fluid" style={{ maxWidth: 1180, padding: "8px 20px 32px" }}>
        {/* Bienvenida */}
        <div
          className="home-hero"
          style={{
            borderRadius: 16,
            padding: "28px 32px",
            marginBottom: 22,
            color: "#fff",
            background: "linear-gradient(135deg, #0f172a 0%, #1e3a8a 60%, #2563eb 100%)",
            boxShadow: "0 10px 30px rgba(30, 58, 138, 0.25)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 20,
            flexWrap: "wrap",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <i
            className="fas fa-ship"
            style={{ position: "absolute", right: -10, bottom: -30, fontSize: "11rem", opacity: 0.07 }}
          />
          <div style={{ position: "relative" }}>
            <div style={{ fontSize: "0.75rem", opacity: 0.75, textTransform: "capitalize", letterSpacing: "0.03em" }}>
              {fecha}
            </div>
            <h2 style={{ margin: "6px 0 6px", fontWeight: 700, fontSize: "1.55rem", color: "#fff" }}>
              {saludo}{user?.nombre ? `, ${user.nombre}` : ""}
            </h2>
            <p style={{ margin: 0, fontSize: "0.85rem", opacity: 0.85, maxWidth: 560 }}>
              {esCliente
                ? t("Consulta el estatus de tus contenedores y tu estado de cuenta.")
                : t("Bienvenido a Moy Logistics. Elige un módulo para empezar o pregúntale al asistente IA.")}
            </p>
          </div>
          <img
            src={process.env.PUBLIC_URL + "/logoInstitucion.png"}
            alt="logo"
            style={{ maxHeight: 64, background: "#fff", borderRadius: 12, padding: "8px 12px", position: "relative" }}
          />
        </div>

        {/* Accesos rápidos */}
        <div
          style={{
            fontSize: "0.66rem", fontWeight: 700, textTransform: "uppercase",
            letterSpacing: "0.09em", color: "#94a3b8", margin: "0 0 12px 2px",
          }}
        >
          {t("Accesos rápidos")}
        </div>
        <div className="row">
          {accesos.map((a) => (
            <div key={a.href} className="col-12 col-sm-6 col-lg-4 mb-3">
              <a
                href={a.href}
                style={{
                  display: "flex", alignItems: "center", gap: 14, padding: "18px 18px",
                  background: "#fff", borderRadius: 12, border: "1px solid #eef2f7",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.06)", textDecoration: "none", height: "100%",
                  transition: "box-shadow 0.15s, transform 0.15s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 8px 22px rgba(15,23,42,0.10)";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.06)";
                  e.currentTarget.style.transform = "none";
                }}
              >
                <div
                  style={{
                    width: 48, height: 48, borderRadius: 12, flexShrink: 0,
                    background: `${a.color}14`, color: a.color,
                    display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.2rem",
                  }}
                >
                  <i className={a.icon} />
                </div>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 700, fontSize: "0.9rem", color: "#0f172a" }}>
                    {esCliente && a.perm === "contenedores" ? t("Mis Contenedores") : t(a.label)}
                  </div>
                  <div style={{ fontSize: "0.72rem", color: "#64748b", lineHeight: 1.35 }}>{t(a.desc)}</div>
                </div>
                <i className="fas fa-chevron-right" style={{ marginLeft: "auto", color: "#cbd5e1", fontSize: "0.75rem" }} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default HomeInicio;
